(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/bottom-sheet/assets/javascripts/shared/utils.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/bottom-sheet/assets/javascripts/shared/utils.trinidad.js');
"use strict";

(() => {
  "use strict";

  var __webpack_require__ = {};
  (() => {
__webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }
      }
    };
  })();
  (() => {
__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  })();
  var __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => (utils)
  });
  ; 

  const DIRECTION_UP = 'up';
  const DIRECTION_DOWN = 'down';
  const DIRECTION_BOTH = 'both';
  const DIRECTION_NONE = 'none';
  const STATE_EXPANDED = 'expanded';
  const STATE_HALF_EXPANDED = 'half-expanded';
  const STATE_COLLAPSED = 'collapsed';
  const STATE_CLOSED = 'closed';
  const BEHAVIOR_STANDARD = 'standard';
  const BEHAVIOR_MODAL = 'modal';
  const BEHAVIOR_HYBRID = 'hybrid';
  const constants = {
    DIRECTION_UP,
    DIRECTION_DOWN,
    DIRECTION_BOTH,
    DIRECTION_NONE,
    STATE_EXPANDED,
    STATE_HALF_EXPANDED,
    STATE_COLLAPSED,
    BEHAVIOR_MODAL,
    BEHAVIOR_STANDARD,
    BEHAVIOR_HYBRID
  };
  ; 
  function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }
    return t;
  }
  function _objectSpread(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }
    return e;
  }
  function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }

  class Utils {
    constructor(options) {
      const defaultSettings = {
        resizeEl: null,
        el: undefined,
        minHeight: 0,
        maxHeight: 0,
        currentHeight: 0,
        isScrollable: false,
        allowedDirections: DIRECTION_BOTH,
        allowClickExpansion: true,
        state: STATE_COLLAPSED,
        allowSwipeResizeFromContent: true,
        startY: 0,
        endY: 0,
        previousY: 0,
        gestureDirection: '',
        isPressed: false,
        isResizing: false,
        startTime: null,
        endTime: null,
        touchController: null,
        swipeController: null
      };
      this.settings = _objectSpread(_objectSpread({}, defaultSettings), options.settings);
    }

    updateSettings(newSettings) {
      this.settings = _objectSpread(_objectSpread({}, this.settings), newSettings);
    }

    getSettings() {
      return this.settings;
    }

    toggleState() {
      const settings = this.settings;
      if (settings.state === STATE_COLLAPSED) {
        settings.gestureDirection = DIRECTION_UP;
      }
      if (settings.state === STATE_EXPANDED) {
        settings.gestureDirection = DIRECTION_DOWN;
      }
      if (settings.state === STATE_HALF_EXPANDED) {
        if (settings.previousState === STATE_COLLAPSED && settings.behavior !== BEHAVIOR_HYBRID) {
          settings.gestureDirection = DIRECTION_UP;
        } else {
          settings.ignoreTwoSteps = true;
          settings.gestureDirection = DIRECTION_DOWN;
        }
      }
      this.setState(0);
    }

    setState(speed, event) {
      const settings = this.settings;
      settings.previousState = this.settings.state;
      if (settings.isFixed) {
        settings.resizeEl.style['max-height'] = "".concat(settings.maxHeight, "px");
      } else {
        if (settings.twoStepExpansion && settings.halfExpandedHeight > 0 && settings.halfExpandedHeight !== settings.currentHeight) {
          if (settings.gestureDirection === DIRECTION_UP) {
            if (settings.currentHeight < settings.halfExpandedHeight) {
              settings.currentHeight = settings.halfExpandedHeight;
              settings.state = STATE_HALF_EXPANDED;
            } else {
              settings.currentHeight = settings.maxHeight;
              settings.state = STATE_EXPANDED;
            }
          } else {
            settings.currentHeight = settings.minHeight;
            settings.state = STATE_COLLAPSED;
          }
        } else {
          if (!(settings !== null && settings !== void 0 && settings.ignoreTwoSteps) && settings.twoStepExpansion && settings.halfExpandedHeight === settings.currentHeight) {
            settings.gestureDirection = DIRECTION_UP;
          }
          if (event !== 'resize') {
            settings.currentHeight = settings.gestureDirection === DIRECTION_UP ? settings.maxHeight : settings.minHeight;
            settings.state = settings.currentHeight === settings.maxHeight ? STATE_EXPANDED : STATE_COLLAPSED;
          }
          if (event === 'resize' && !settings.isFixed) {
            settings.currentHeight = settings.maxHeight;
          }
        }
        settings.el && settings.el.querySelector('.js-bottom-sheet-collapse') && settings.el.querySelector('.js-bottom-sheet-collapse').classList["".concat(settings.state === STATE_COLLAPSED ? 'add' : 'remove')]('bottom-sheet-close-hide');
        settings.resizeEl.style.transitionDuration = "".concat(speed && speed < 0.7 ? "".concat(speed, "s") : "".concat(settings.maxHeight / 1.5, "ms"));
        if (settings.imgEl) {
          settings.imgEl.style.transitionDuration = "".concat(speed && speed < 0.7 ? "".concat(speed, "s") : "".concat(settings.maxHeight / 1.5, "ms"));
        }

        if (settings.imgEl && settings.imgHeight && settings.currentHeight > settings.minHeight) {
          settings.imgHeight = 144 + (settings.currentHeight - settings.minHeight);
          if (settings.imgHeight > 278) {
            settings.imgHeight = 278;
          }
        } else if (settings.imgEl) {
          settings.imgHeight = 144;
        }
        if (settings.imgEl) {
          settings.imgEl.style.height = "".concat(settings.imgHeight, "px");
          settings.root.style.setProperty('--bottom-sheet-header-image-height', "".concat(settings.imgHeight, "px"));
        }

        settings.resizeEl.style['max-height'] = "".concat(settings.currentHeight, "px");
        settings.resizeEl.style.overflow = "".concat(settings.currentHeight > 0 && settings.state !== STATE_COLLAPSED ? '' : 'hidden');
      }
      if (settings.behavior === BEHAVIOR_MODAL && settings.state !== STATE_EXPANDED) {
        document.querySelector('body').style.overflowY = 'unset';
      }
      this.updateSettings(settings);

      setTimeout(() => {
        const drawerEl = document.querySelector('.js-drawer-sheet');
        if (settings.behavior === BEHAVIOR_HYBRID && settings.state !== STATE_COLLAPSED) {
          if (drawerEl && drawerEl.style) {
            drawerEl.style.zIndex = '1102'; 
          }
        } else if (settings.behavior !== BEHAVIOR_MODAL) {
          if (drawerEl && drawerEl.style) {
            drawerEl.style.zIndex = '1089';
          }
        }
        this.handleDimmer();
      }, settings.gestureDirection === DIRECTION_DOWN ? 0 : speed && speed < 0.7 ? speed / 2 : 250);
    }

    setMeasurements(isExpanded, event) {
      var _sheet$querySelector, _sheet$querySelector2, _sheet$querySelector3, _sheet$querySelector4;
      const settings = this.getSettings();
      const sheet = document.querySelector(".js-bottom-sheet-".concat(settings.id));
      const footerHeight = (_sheet$querySelector = sheet.querySelector('.bottom-sheet-footer')) !== null && _sheet$querySelector !== void 0 && _sheet$querySelector.clientHeight ? (_sheet$querySelector2 = sheet.querySelector('.bottom-sheet-footer')) === null || _sheet$querySelector2 === void 0 ? void 0 : _sheet$querySelector2.clientHeight : 0;
      const imageHeight = (_sheet$querySelector3 = sheet.querySelector('.bottom-sheet-header-image')) !== null && _sheet$querySelector3 !== void 0 && _sheet$querySelector3.clientHeight ? (_sheet$querySelector4 = sheet.querySelector('.bottom-sheet-header-image')) === null || _sheet$querySelector4 === void 0 ? void 0 : _sheet$querySelector4.clientHeight : 0;
      const maxAvailableHeight = visualViewport.height - 36;
      settings.imgEl = sheet.querySelector('.bottom-sheet-header-image') ? sheet.querySelector('.bottom-sheet-header-image') : false;
      settings.root = document.documentElement;
      settings.resizeEl = sheet.querySelector('.js-bottom-sheet-content');
      const maxHeight = maxAvailableHeight;
      settings.startWatch = sheet.querySelector('.js-bottom-sheet-watch-start');
      settings.endWatch = sheet.querySelector('.js-bottom-sheet-watch-end');
      settings.resizeElInitialHeight = settings.resizeEl.clientHeight;
      settings.sheet = sheet;
      if (imageHeight > 0) {
        const image = sheet.querySelector('.bottom-sheet-header-image-img');
        image.draggable = false;
        if (settings.allowHeaderSwipe) {
          image.style.cursor = 'ns-resize';
        }
      }
      if (footerHeight) {
        settings.root.style.setProperty('--bottom-sheet-content-padding-bottom', "".concat(footerHeight, "px"));
        settings.root.style.setProperty('--bottom-sheet-content-scrollbar-bottom', "".concat(footerHeight, "px"));
      }
      if (settings.collapsedHeight !== 0 && !Number.isInteger(settings.collapsedHeight) && settings.collapsedHeight.includes('%')) {
        settings.collapsedHeight = Math.round(maxAvailableHeight * (parseInt(settings.collapsedHeight.split('%')[0], 10) / 100));
      }

      if (!Number.isInteger(settings.collapsedHeight)) {
        settings.collapsedHeight = parseInt(settings.collapsedHeight.split('px')[0], 10);
        settings.defaultCollapsedHeight = parseInt(settings.defaultCollapsedHeight.split('px')[0], 10);
      }

      if (imageHeight) {
        settings.collapsedHeight = settings.collapsedHeight + imageHeight;
      }

      if (!settings.isFixed && settings.defaultCollapsedHeight === settings.collapsedHeight) {
        const controlHeight = sheet.querySelector('.js-bottom-sheet-header-control').clientHeight;

        if (settings.collapsedHeight + controlHeight > maxAvailableHeight) {
          settings.collapsedHeight = maxAvailableHeight;
        } else {
          settings.collapsedHeight = settings.collapsedHeight + controlHeight;
        }
      }

      if (!settings.collapsedHeight) {
        settings.collapsedHeight = footerHeight;
      }

      settings.collapsedHeight = "".concat(settings.collapsedHeight, "px");
      settings.defaultCollapsedHeight = "".concat(settings.defaultCollapsedHeight, "px");
      settings.resizeEl.style['max-height'] = settings.collapsedHeight;
      settings.minHeight = footerHeight + parseInt(settings.collapsedHeight.split('px')[0], 10);
      settings.halfExpandedHeight = settings.twoStepExpansion ? visualViewport.height / 2 : 0;
      settings.maxHeight = maxHeight > maxAvailableHeight ? maxAvailableHeight : maxHeight;
      settings.isScrollable = maxHeight > maxAvailableHeight;

      if (settings.maxHeight - settings.halfExpandedHeight < visualViewport.height / 3) {
        settings.twoStepExpansion = false;
      }
      if (settings.behavior === BEHAVIOR_MODAL) {
        document.querySelector('.js-drawer-sheet').style.zIndex = '1102';
      }

      if (!settings.disablePageContentSpacing) {
        const padding = document.querySelector('.js-bottom-sheet').clientHeight + 24;
        const el = document.querySelector('footer') ? document.querySelector('footer') : document.querySelector('body');

        if (!el.dataset.pBottom) {
          el.dataset.pBottom = "".concat(parseInt(window.getComputedStyle(el).getPropertyValue('padding-bottom').split('px')[0], 10));
        }
        el.style['padding-bottom'] = "".concat(parseInt(el.dataset.pBottom, 10) + padding, "px");
      }
      if (isExpanded) {
        settings.gestureDirection = DIRECTION_UP;
      }
      this.updateSettings(settings);
      this.setState(0, event);
    }

    handleDimmer() {
      var _settings$bottomSheet, _settings$bottomSheet2, _settings$bottomSheet3;
      const settings = this.getSettings();
      if (settings.behavior !== BEHAVIOR_STANDARD && settings.state === STATE_COLLAPSED && typeof (settings === null || settings === void 0 || (_settings$bottomSheet = settings.bottomSheet) === null || _settings$bottomSheet === void 0 ? void 0 : _settings$bottomSheet.hideDimmer) === 'function') {
        settings.bottomSheet.hideDimmer();
      }
      if (settings.behavior !== BEHAVIOR_STANDARD && (settings.state === STATE_EXPANDED || settings.state === STATE_HALF_EXPANDED) && typeof (settings === null || settings === void 0 || (_settings$bottomSheet2 = settings.bottomSheet) === null || _settings$bottomSheet2 === void 0 ? void 0 : _settings$bottomSheet2.showDimmer) === 'function') {
        settings.bottomSheet.showDimmer();
      }
      if (settings.behavior === BEHAVIOR_MODAL && typeof (settings === null || settings === void 0 || (_settings$bottomSheet3 = settings.bottomSheet) === null || _settings$bottomSheet3 === void 0 ? void 0 : _settings$bottomSheet3.showDimmer) === 'function') {
        settings.bottomSheet.showDimmer();
      }
      if (settings.onStateChange) {
        settings.onStateChange({
          state: settings.state,
          measurements: {
            currentHeight: settings.currentHeight,
            minHeight: settings.minHeight,
            maxHeight: settings.maxHeight,
            halfExpandedHeight: settings.halfExpandedHeight,
            collapsedHeight: settings.collapsedHeight
          }
        });
      }

      if (settings.state === STATE_COLLAPSED) {
        settings.resizeEl.scrollTop = 0;
      }
      this.updateSettings(settings);
    }

    resetStates() {
      var _settings$swipeContro;
      const settings = this.getSettings();
      (_settings$swipeContro = settings.swipeController) === null || _settings$swipeContro === void 0 || _settings$swipeContro.abort();
      settings.isResizing = false;
      settings.startY = 0;
      settings.endY = 0;
      settings.previousY = 0;
      settings.startTime = null;
      settings.endTime = null;
      settings.ignoreTwoSteps = false;
      if (settings.behavior !== BEHAVIOR_MODAL) {
        document.querySelector('body').style.overflowY = 'unset';
      }
      this.updateSettings(settings);
    }
    destroy() {
      var _settings$touchContro, _settings$swipeContro2;
      const settings = this.getSettings();
      (_settings$touchContro = settings.touchController) === null || _settings$touchContro === void 0 || _settings$touchContro.abort();
      (_settings$swipeContro2 = settings.swipeController) === null || _settings$swipeContro2 === void 0 || _settings$swipeContro2.abort();
    }
  }
  const utils = Utils;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).BottomSheet = window.svs.ui.BottomSheet || {}).BottomSheetUtils = __webpack_exports__["default"];
})();

 })(window);